import React from 'react';
import StudentForm from '../../../../components/forms/StudentForm';

export default function TeamStudentsCreatePage() {
  return <StudentForm />;
}
